import React, { memo, useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import { Link } from 'react-router-dom';

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import './avatar.scss';
import { useTranslation } from 'react-i18next';
import { useKeycloak } from '@react-keycloak/web';
import PROFILE from 'api/queries/PROFILE';
import StaticImageIcon from 'images/icons/static-image.png';
import env from 'utils/env';

const Avatar = () => {
  const { t } = useTranslation('authentication');
  const { client, loading, data } = useQuery(PROFILE);
  const [avatarSrc, setAvatarSrc] = useState('');
  const [avatarMenu, toggleMenu] = useState(null);
  const { keycloak } = useKeycloak();

  const handleAvatarError = () => setAvatarSrc(StaticImageIcon);

  const handleClick = (event) => {
    toggleMenu(event.currentTarget);
  };

  const handleClose = () => {
    toggleMenu(null);
  };

  useEffect(() => {
    if (!loading) {
      localStorage.setItem('userId', data?.me?.id);
      localStorage.setItem('userAvatarSrc', `${env.static}/${data?.me?.avatar}`);
      setAvatarSrc(`${env.static}/${data?.me?.avatar}`);
    }
  }, [data, loading]);

  const logOut = () => {
    keycloak.logout().then(() => {
      localStorage.removeItem('idToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('token');
      localStorage.removeItem('userId');
      localStorage.removeItem('userAvatarSrc');
      sessionStorage.removeItem('token');
      client.resetStore();
    });
  };

  if (loading) return '...';

  return (
    <div data-testid="avatar-wrapper" className="avatar">
      <img
        alt="Avatar"
        aria-hidden
        className="avatar__img"
        onError={handleAvatarError}
        onClick={handleClick}
        src={avatarSrc}
      />

      <Menu
        id="avatar-menu"
        anchorEl={avatarMenu}
        keepMounted
        open={Boolean(avatarMenu)}
        onClose={handleClose}
      >
        <Link className="avatar_profile" to="/user-profile">
          <MenuItem onClick={handleClose}>{t('profile')}</MenuItem>
        </Link>

        <MenuItem onClick={logOut}>
          <Link className="avatar_logout" to="/">
            {t('logout')}
          </Link>
        </MenuItem>
      </Menu>
    </div>
  );
};

export default memo(Avatar);
